function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.907 0H13.093v14.171H.5L20.5 32l20-17.829H27.907V0z",
  fill: "url(#mobileArrow_svg__paint0_linear_4184_6172)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobileArrow_svg__paint0_linear_4184_6172",
  x1: 20.5,
  y1: -21.486,
  x2: 20.5,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5445FF",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6270FF",
  stopOpacity: 0.4
})));

function SvgMobileArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMobileArrow;